var _polyline, _polyline2, _line, _circle, _polyline3, _circle2, _polyline4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "w-6 h-6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#F2C66DFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "13,7 13,27 1,27 1,16 ",
    strokeLinejoin: "miter",
    strokeLinecap: "butt"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F2C66DFF",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    points: "24,27 31,27 31,18 25,16 23,9 13,9 ",
    strokeLinejoin: "miter"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#F2C66DFF",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    x1: 13,
    y1: 27,
    x2: 16,
    y2: 27,
    strokeLinejoin: "miter"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#F2C66DFF",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    cx: 20,
    cy: 27,
    r: 4,
    strokeLinejoin: "miter"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#F2C66DFF",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    points: "17,13 17,16 21,16 ",
    strokeLinejoin: "miter"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    fill: "none",
    stroke: "#F2C66DFF",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    cx: 7,
    cy: 7,
    r: 6,
    strokeLinejoin: "miter"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    "data-color": "color-2",
    fill: "none",
    stroke: "#F2C66DFF",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    points: " 7,5 7,7 9,7 ",
    strokeLinejoin: "miter"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/deliveryTruck.62d64f200f7cdf12808c8f9c171127cd.svg";
export { ForwardRef as ReactComponent };